import { render, staticRenderFns } from "./CardOffice.vue?vue&type=template&id=1c1367ce&scoped=true&"
import script from "./CardOffice.vue?vue&type=script&lang=ts&"
export * from "./CardOffice.vue?vue&type=script&lang=ts&"
import style0 from "./CardOffice.vue?vue&type=style&index=0&id=1c1367ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1367ce",
  null
  
)

export default component.exports